import React, { useState } from 'react';
import './ClientPortal.css';

const ClientLoginPage = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await fetch('/api/login/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await res.json();
            if (!res.ok) {
                setError(data.detail || 'Invalid username or password.');
                return;
            }

            // Verify this is a customer portal user
            const profile = data.permissions;
            const userType = data.user_type;
            if (userType && userType !== 'CUSTOMER') {
                setError('This portal is for customers only. Please use the main application.');
                return;
            }

            onLoginSuccess(data);
        } catch {
            setError('Connection error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="cp-login-root">
            <div className="cp-login-box">
                <div className="cp-login-logo">
                    <div className="logo-icon">
                        <i className="fa-solid fa-building-user"></i>
                    </div>
                    <h1>K&amp;K Client Portal</h1>
                    <p>Sign in to track your shipments</p>
                </div>

                {error && <div className="cp-login-error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                            autoFocus
                            autoComplete="username"
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>
                    <button type="submit" className="cp-login-submit" disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ClientLoginPage;
